import PropTypes from 'prop-types'
import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import Button from './Button'
import Link from './Link'
import Logo from './Logo'
import HamburgerButton from './HamburgerButton'
import Menu from './Menu'
import { BannersController } from '../components/banners'

import { AIR_URL, CONSOLE_URL, MAKERS_URL, TOKEN_SALE_URL } from '../../config'

import { trackThenLeaveToDevConsole } from '../../utils/tracking'

// only used for large screens
// - for small screens different menu options,
// shown in Hamburger menu (in Menu component)
const LINKS = [
  {
    label: 'Snips AIR',
    href: AIR_URL,
    forceAnchorElement: true
  },
  {
    label: 'Developers',
    href: MAKERS_URL,
    forceAnchorElement: true
  },
  {
    label: 'Enterprise',
    href: '/enterprise/'
  },
  {
    label: 'Technology',
    href: '/technology/'
  },
  {
    label: 'Token Sale',
    href: TOKEN_SALE_URL,
    forceAnchorElement: true
  }
]

const Header = class Header extends Component {
  render () {
    const { activePathname, darkHeaderBackground, isAtScrollZero } = this.props
    const enterprisePage = activePathname === '/enterprise/'
    const classes = classnames(
      {
        'header--initial-state': isAtScrollZero,
        'header--on-light-bg': !darkHeaderBackground
      },
      'header flex align-items'
    )
    return (
      <Fragment>
        <header className={classes}>
          <div className='header__content maxw-xxlarge mx-auto flex items-center justify-between px2'>
            <Link href='/' className={
              classnames({'header__logo--enterprise': enterprisePage}, 'header__logo')}>
              {!enterprisePage ? <Logo /> : <Logo icon='logo--enterprise' />}
            </Link>
            <div className='header__small-view'>
              <Menu />
              <HamburgerButton
                onTopOfDarkSection={isAtScrollZero || darkHeaderBackground}
              />
            </div>
            <nav className='header__group--main ml-auto mr1'>
              <ul className='flex'>
                {LINKS.map(
                  (
                    { extraClass, label, href, forceAnchorElement, target },
                    idx
                  ) => {
                    const activePage = href === activePathname
                    const linkItemClasses = classnames(
                      {
                        'header__link--active': activePage,
                        [extraClass]: !!extraClass
                      },
                      'px2 header__link'
                    )

                    return (
                      <li className='header__item' key={idx}>
                        <Button
                          className={linkItemClasses}
                          href={href}
                          target={target}
                          forceAnchorElement={forceAnchorElement}
                        >
                          {label}
                        </Button>
                      </li>
                    )
                  }
                )}
              </ul>
            </nav>

            <div className='items-center header__group'>
              {/*
              <div className='header__item'>
              <Link
                className='py1 px2 header__link'
                href={CONSOLE_LOGIN_URL}
                target='_blank'
                forceAnchorElement
              >
                Log in
              </Link>
            </div>
            */}
              <div className='header__item'>
                <Button
                  className='button button--primary header__cta-button'
                  href={CONSOLE_URL}
                  onClick={e => trackThenLeaveToDevConsole(e, 'Header')}
                  forceAnchorElement
                >
                  Sign Up
                </Button>
              </div>
            </div>
          </div>
        </header>
        <BannersController />
      </Fragment>
    )
  }
}

Header.propTypes = {
  darkHeaderBackground: PropTypes.bool,
  activePathname: PropTypes.string.isRequired,
  isAtScrollZero: PropTypes.bool
}

const mapStateToProps = ({ location }) => {
  return {
    activePathname: location.pathname
  }
}

export default connect(mapStateToProps, null)(Header)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Header.js